export const SELECT_ALL_KEY = '__select_all__';
export const NO_RESULTS = 'no-results';
